import { MetricsSuites } from "./MetricsSuites";

export enum MetricsEventType {
  null = "null",
  navigation = "nav",
  contextEnd = "wp",
  generic = "gen",
  sessionInit = "init",
}

export class MetricsEventParameters {
  public description?: string;
  public time?: number;
  public elapsed?: number;
  public id?: string;
  public values?: Array<number>;
  public metricsSessionId?: string;
  public extraInfo?: string;
  public workbook?: string;
  public sheet?: string;
  public isMobile?: boolean;
  public properties?: string;
  public clientEventId?: string;
  public vizclientSessionId?: string;
  public sessionType?: string;
  public traceId?: string;
}

export function getMetricsParameterShortName(
  metricsParameterName: string
): string | null {
  switch (metricsParameterName) {
    case "description":
      return "d";
    case "time":
      return "t";
    case "id":
      return "id";
    case "elapsed":
      return "e";
    case "values":
      return "v";
    case "metricsSessionId":
      return "sid";
    case "extraInfo":
      return "ei";
    case "workbook":
      return "wb";
    case "sheet":
      return "s";
    case "isMobile":
      return "m";
    case "properties":
      return "p";
    case "clientEventId":
      return "cid";
    case "vizclientSessionId":
      return "vsid";
    case "sessionType":
      return "st";
    case "traceId":
      return "trid";
    default:
      return null;
  }
}

// Class representing a single timing event
export class MetricsEvent {
  constructor(
    private _eventType: MetricsEventType = MetricsEventType.null,
    private _metricSuite: MetricsSuites,
    private _parameters: MetricsEventParameters
  ) {}

  get eventType(): MetricsEventType {
    return this._eventType;
  }

  get metricSuite(): MetricsSuites {
    return this._metricSuite;
  }

  get parameters(): MetricsEventParameters {
    return this._parameters;
  }
}
